module.exports = __webpack_public_path__ + "img/m3.3b62bd32.svg";